<template>
  <CCarousel
      arrows
      indicators
      animate
      :interval="3000"
      height="600px"
  >
    <c-carousel-item
    >
      <img src="/carousel-1.jpg" class="carousel-img">
      <div class="carousel-caption">
        <h2>Warzywa</h2>
      </div>
    </c-carousel-item>
    <c-carousel-item
    >
      <img src="/carousel-2.jpg" class="carousel-img">
      <div class="carousel-caption">
        <h1>Owoce</h1>
      </div>
    </c-carousel-item>
    <c-carousel-item
    >
      <img src="/carousel-3.jpg" class="carousel-img">
      <div class="carousel-caption">
        <h1>Przetwory</h1>
      </div>
    </c-carousel-item>
  </CCarousel>
</template>
<script>
export default {
  name: 'TheMainCarousel'
}
</script>
<style>
.carousel-img {
  width: 100%;
  height: 600px;
  object-fit: cover;
  object-position: center;
}
</style>